import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureCosmosMongoDbApiCopySource } from 'app/model/pipeline/copysource/azure-cosmos-mongodb-api.copysource';
import { toCursorMethodObject, toCursorMethodClass } from 'app/model/adapters/linkedservices/cursor-method.util';
import { isLogicAppExpression, isExpressionObject } from '../../../../shared/utils/expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureCosmosMongoDbApiCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        batchSize: '*',
        filter: '*',
        cursorMethods: '*'
    }
})
export class AzureCosmosMongoDbApiCopySourceAdapter extends CopySourceAdapter<
    AzureCosmosMongoDbApiCopySource,
    Model.DocumentDbMongoApiCollectionSource
> {
    protected override async _toResource(
        copySource: AzureCosmosMongoDbApiCopySource
    ): Promise<Model.DocumentDbMongoApiCollectionSource> {
        const result: Model.DocumentDbMongoApiCollectionSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(AzureCosmosMongoDbApiCopySource).name
        );
        result.batchSize = ValueAdapter.toResource(copySource, AzureCosmosMongoDbApiCopySource.BATCH_SIZE);
        result.filter = ValueAdapter.toResource(copySource, AzureCosmosMongoDbApiCopySource.FILTER);
        const cursorMethodsValue =
            AzureCosmosMongoDbApiCopySource.CURSORMETHODS != null
                ? AzureCosmosMongoDbApiCopySource.CURSORMETHODS.templateValue(copySource)
                : undefined;
        result.cursorMethods =
            cursorMethodsValue != null
                ? ValueAdapter.toResource(copySource, AzureCosmosMongoDbApiCopySource.CURSORMETHODS)
                : toCursorMethodObject(copySource.cursorMethods);
        return result;
    }

    protected override async _toModel(
        resource: Model.DocumentDbMongoApiCollectionSource,
        copyActivity: CopyActivity
    ): Promise<AzureCosmosMongoDbApiCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureCosmosMongoDbApiCopySource.MODEL,
            resource,
            copyActivity
        ) as AzureCosmosMongoDbApiCopySource;
        ValueAdapter.toModel(result, AzureCosmosMongoDbApiCopySource.BATCH_SIZE, resource.batchSize);
        ValueAdapter.toModel(result, AzureCosmosMongoDbApiCopySource.FILTER, resource.filter);
        if (
            resource.cursorMethods != null &&
            (isExpressionObject(resource.cursorMethods) || isLogicAppExpression(resource.cursorMethods))
        ) {
            ValueAdapter.toModel(result, AzureCosmosMongoDbApiCopySource.CURSORMETHODS, resource.cursorMethods);
        } else {
            result.cursorMethods = toCursorMethodClass(resource.cursorMethods, result);
        }
        return result;
    }
}
